import React from "react";
import "./HF.css"; // Create a CSS file for footer-specific styles
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
// import world from "../assets/footerimage.jpg";

const Footer = () => (
  // <div>

  // </div>
  <div className="footer">
    {/* <img className="logo" src={world} alt="world" /> */}
    <div className="footer-container">
      {/* OUR MISSION STATEMENT */}
      <div className="mission">
        <h3>About Us</h3>

        <p>
          Ambrosys Business Solutions Pvt Ltd Corporate is a business consulting
          and It services firm dedicated to infrastructure services, financial
          inter-mediation, professional consulting, HR services, outsourcing and
          BPO. We do head hunting too. We help you in finding the right
          candidate.
        </p>
      </div>

      {/* main links */}
      <div className="mainlinks">
        <h3>Main Links</h3>
        <ul>
          <li>
            <a
              target="blank"
              href="https://ambrosyscorp.com/business-applications/"
            >
              Software Development
            </a>
          </li>
          <li>
            <a target="blank" href="https://ambrosyscorp.com/cloud-services/">
              Cloud Services
            </a>
          </li>
          <li>
            <a
              target="blank"
              href="https://ambrosyscorp.com/it-managed-services/"
            >
              IT Managed services
            </a>
          </li>
          <li>
            <a target="blank" href="https://ambrosyscorp.com/it-support/">
              IT Support
            </a>
          </li>
        </ul>
      </div>

      <div className="quicklinks">
        <h3>Quick Links</h3>
        <ul>
          <li>
            <a target="blank" href="https://ambrosyscorp.com/">
              Home
            </a>
          </li>
          <li>
            <a target="blank" href="https://ambrosyscorp.com/about-us/">
              About
            </a>
          </li>
          <li>
            <a target="blank" href="https://ambrosyscorp.com/industries/">
              Industries
            </a>
          </li>
          <li>
            <a target="blank" href="https://ambrosyscorp.com/contact-us/">
              contact
            </a>
          </li>
        </ul>
      </div>

      {/* CONTACT US */}
      <div className="contact-us">
        <h3>CONTACT US</h3>
        <p>
          <a>+91 95666 60086</a> <br />
          <a target="blank" href="mailto:info@ambrosyscorp.com">
            info@ambrosyscorp.com
          </a>
        </p>
        <div className="social-icons">
          <a
            target="blank"
            href="https://facebook.com/LayamGroup"
            rel="noopener noreferrer"
            className="fbook"
          >
            <FaFacebook />
          </a>
          <a
            target="blank"
            href="https://linkedin.com/company/layam-management-solutions-pvt-ltd"
            rel="noopener noreferrer"
            className="linkin"
          >
            <FaLinkedin />
          </a>
          <a
            target="blank"
            href="https://x.com/i/flow/login?redirect_after_login=%2FLayamGroup"
            rel="noopener noreferrer"
            className="twitter"
          >
            <FaXTwitter />
          </a>
          <a
            target="blank"
            href="https://www.instagram.com/ambrosyscorp/"
            rel="noopener noreferrer"
            className="instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
    </div>
    <div className="line"></div>
    <div className="RENO">
      <p>&copy; Copyright 2025 Reno HR. All Rights Reserved.</p>
    </div>
    <div className="company">
      <h5>
        {" "}
        Developed by
        <span>
          <a target="blank" href="https://ambrosyscorp.com/" className="abs">
            AMBROSYS
          </a>
        </span>
      </h5>
    </div>
  </div>
);

export default Footer;
